import CONNECTORS from './connectors.gql';
import SAVE_BUSINESS_REQUEST from './saveBusinessRequest.gql';

export {
  CONNECTORS,
  SAVE_BUSINESS_REQUEST,
};
